'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'face-glasses';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e377';
var svgPathData = 'M492 299.7C471.5 411.4 373.6 496 256 496S40.5 411.4 20 299.7C11.9 291.6 5.2 282 .5 271.5 8.5 405.6 119.8 512 256 512S503.5 405.6 511.5 271.5c-4.8 10.6-11.4 20.2-19.5 28.3zM256 16c58.7 0 112.4 21 154.1 56L424 72c3.6 0 7.1 .2 10.6 .6-46.1-44.9-109.1-72.6-178.6-72.6S123.5 27.7 77.4 72.6c3.5-.4 7-.6 10.6-.6l13.9 0C143.6 37 197.3 16 256 16zM149.2 348.2c-2.7-3.5-7.8-4.1-11.2-1.3s-4.1 7.8-1.3 11.2c27.8 35.3 71 57.9 119.4 57.9s91.6-22.7 119.4-57.9c2.7-3.5 2.1-8.5-1.3-11.2s-8.5-2.1-11.2 1.3C337.9 379.7 299.3 400 256 400s-81.9-20.3-106.8-51.8zM272 232c0 30.9 25.1 56 56 56l96 0c30.9 0 56-25.1 56-56l0-56 24 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-24.6 0c-3.9-27.1-27.2-48-55.4-48l-96 0c-28.2 0-51.6 20.9-55.4 48l-33.1 0c-3.9-27.1-27.2-48-55.4-48l-96 0c-28.2 0-51.6 20.9-55.4 48L8 160c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0 0 56c0 30.9 25.1 56 56 56l96 0c30.9 0 56-25.1 56-56l0-56 32 0 0 56zm16-56l0-8c0-22.1 17.9-40 40-40l96 0c22.1 0 40 17.9 40 40l0 64c0 22.1-17.9 40-40 40l-96 0c-22.1 0-40-17.9-40-40l0-56zm-64-8l0 64c0 22.1-17.9 40-40 40l-96 0c-22.1 0-40-17.9-40-40l0-64c0-22.1 17.9-40 40-40l96 0c22.1 0 40 17.9 40 40zm-32 40a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceGlasses = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;